import { DiagnosisOption } from '../imageDiagnosisTypes';

export const booleanOptions: DiagnosisOption[] = [
  {
    label: '-',
    value: 0,
    color: '#6C9E6E'
  },
  {
    label: '+',
    value: 1,
    color: '#c85b30'
  }
];
